import React, { useState, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TalkToAnSCESpecialist from "../components/TalkToAnSCESpecialist";
import { colors, typography } from "@src/styles";

const StickyFooter = () => {
  const [stuck, setStuck] = useState(true);
  const containerRef = useCallback((ref: React.Ref<HTMLDivElement> | null) => {
    if (!(ref && "current" in ref && ref.current)) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 1) {
          setStuck(false);
        } else {
          setStuck(true);
        }
      },
      {
        rootMargin: "0px",
        threshold: 1,
      },
    );

    observer.observe(ref.current as Element);
  }, []);

  return (
    <div className="container-fluid d-block d-sm-none">
      <Row>
        <Col className="p-0" ref={containerRef}>
          <div
            className="w-100 p-2"
            style={{
              position: stuck ? "fixed" : "static",
              left: 0,
              bottom: 0,
              zIndex: 99,
              backgroundColor: colors.secondary,
              fontWeight: typography.weight.bold,
              textAlign: "center",
            }}
          >
            <div className="d-flex justify-content-center align-items-center">
              <TalkToAnSCESpecialist
                linkProps={{
                  className: "btn btn-dark bold text-primary rounded-0 py-2 w-100",
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StickyFooter;
